export const prettifyURL = url => {
  const prettyURL = String(url.match(/^[^:/?#]+:?\/\/[^/?#]*/)[0])
  return prettyURL
}
